import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.find.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as types from './types';
import LOGS from '~/const/errorsLog';
import USE_MERCURE from '~/const/mercure';
import { isValidToken } from '~/helpers/connection-helper';
import { encodeSha256 } from '~/helpers/crypto-helper';
import logout from '~/helpers/logout-helper';
import { createCart, fetchCart as _fetchCart, fetchCartTotalQuantity as _fetchCartTotalQuantity, addCart, updateCart, addCartCustomizable as _addCartCustomizable, addGiftCardToCart, addSellerIdToCart } from '~/services/cart';
import { fetchCustomerCart, addCustomerCart, addCustomerCartCustomizable, updateCustomerCart } from '~/services/customer';
var formatCustomerCartQuantity = function formatCustomerCartQuantity(data) {
  var qty = data.split('|').find(function (a) {
    return a.includes('item_qty');
  });
  qty = qty ? qty.replace('item_qty:', '') : 0;
  return parseInt(qty, 10) || 0;
};
var getGraphQLErrorsCode = function getGraphQLErrorsCode(err) {
  if (err && err.length) {
    return err[0].extensions.code || '';
  }
  return '';
};
var initCart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context) {
    var _yield$createCart, createNewCart;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          sessionStorage.removeItem('MDM_CART_ADDRESSES');
          sessionStorage.removeItem('MDM_CART_PHONE');
          sessionStorage.removeItem('MDM_RESTORE_CART');
          sessionStorage.removeItem('MDM_CC_ELIGIBLE');
          _context.next = 6;
          return createCart(context, localStorage.getItem('MDM_ACCESS_TOKEN'));
        case 6:
          _yield$createCart = _context.sent;
          createNewCart = _yield$createCart.createNewCart;
          if (createNewCart) {
            _context.next = 10;
            break;
          }
          throw new Error('MDM_CART_CANNOT_CREATE_TOKEN');
        case 10:
          localStorage.setItem('MDM_CART_TOKEN', createNewCart);
          return _context.abrupt("return", createNewCart);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function initCart(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default {
  createCart: function createCart() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var cartToken;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return initCart(_this);
          case 3:
            cartToken = _context2.sent;
            return _context2.abrupt("return", cartToken);
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            _this.$logger.error('CREATE CART FAILED', _context2.t0);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 7]]);
    }))();
  },
  fetchCart: function fetchCart(_ref2) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit, user, cart, quantity, _yield$_fetchCart, minicart, errors, code, data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref2.commit;
            user = _this2.getters['user/me'];
            cart = null;
            quantity = null;
            _context3.prev = 4;
            if (!USE_MERCURE(_this2.getters['i18n/locale'].iso)) {
              _context3.next = 22;
              break;
            }
            if (localStorage.getItem('MDM_CART_TOKEN')) {
              _context3.next = 8;
              break;
            }
            return _context3.abrupt("return");
          case 8:
            _context3.next = 10;
            return _fetchCart(_this2, {
              reference: localStorage.getItem('MDM_CART_TOKEN'),
              token: localStorage.getItem('MDM_ACCESS_TOKEN')
            });
          case 10:
            _yield$_fetchCart = _context3.sent;
            minicart = _yield$_fetchCart.data.minicart;
            errors = _yield$_fetchCart.errors;
            if (!errors) {
              _context3.next = 17;
              break;
            }
            code = getGraphQLErrorsCode(errors);
            if (code === 'MERCURE_ERROR_CART_NOTFOUND') {
              localStorage.removeItem('MDM_CART_TOKEN');
            }
            throw new Error(errors);
          case 17:
            cart = minicart.items;
            quantity = minicart.quantity;
            commit(types.SET_CART_STATE, 'SUCCESS');
            _context3.next = 28;
            break;
          case 22:
            localStorage.removeItem('MDM_CART_TOKEN');
            _context3.next = 25;
            return fetchCustomerCart(_this2);
          case 25:
            data = _context3.sent;
            quantity = data.cart;
            if (data && data.user) {
              localStorage.setItem('MDM_MAILS', {
                type_A: data.user.user_email,
                type_B: encodeSha256(user.email)
              });
            }
          case 28:
            _context3.next = 34;
            break;
          case 30:
            _context3.prev = 30;
            _context3.t0 = _context3["catch"](4);
            _this2.$logger.error(_context3.t0);
            commit(types.SET_CART_STATE, 'ERROR');
          case 34:
            _context3.prev = 34;
            commit(types.SET_CART, cart);
            commit(types.SET_CART_QTY, quantity);
            return _context3.finish(34);
          case 38:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[4, 30, 34, 38]]);
    }))();
  },
  fetchCartTotalQuantity: function fetchCartTotalQuantity(_ref3) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var commit, quantity, _yield$_fetchCartTota, data, errors, code, _data;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref3.commit;
            quantity = null;
            _context4.prev = 2;
            if (!USE_MERCURE(_this3.getters['i18n/locale'].iso)) {
              _context4.next = 19;
              break;
            }
            if (localStorage.getItem('MDM_CART_TOKEN')) {
              _context4.next = 6;
              break;
            }
            return _context4.abrupt("return");
          case 6:
            _context4.next = 8;
            return _fetchCartTotalQuantity(_this3, {
              reference: localStorage.getItem('MDM_CART_TOKEN'),
              token: localStorage.getItem('MDM_ACCESS_TOKEN')
            });
          case 8:
            _yield$_fetchCartTota = _context4.sent;
            data = _yield$_fetchCartTota.data;
            errors = _yield$_fetchCartTota.errors;
            if (!errors) {
              _context4.next = 15;
              break;
            }
            code = getGraphQLErrorsCode(errors);
            if (code === 'MERCURE_ERROR_CART_NOTFOUND') {
              localStorage.removeItem('MDM_CART_TOKEN');
            }
            throw new Error(errors);
          case 15:
            quantity = data.cartTotalQuantity;
            commit(types.SET_CART_STATE, 'SUCCESS');
            _context4.next = 24;
            break;
          case 19:
            localStorage.removeItem('MDM_CART_TOKEN');
            _context4.next = 22;
            return fetchCustomerCart(_this3);
          case 22:
            _data = _context4.sent;
            quantity = _data.cartTotalQuantity;
          case 24:
            _context4.next = 30;
            break;
          case 26:
            _context4.prev = 26;
            _context4.t0 = _context4["catch"](2);
            _this3.$logger.error(_context4.t0);
            commit(types.SET_CART_STATE, 'ERROR');
          case 30:
            _context4.prev = 30;
            commit(types.SET_CART_QTY, quantity);
            return _context4.finish(30);
          case 33:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 26, 30, 33]]);
    }))();
  },
  addGiftCard: function addGiftCard(_ref4, _ref5) {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var commit, context, senderName, recipientName, recipientEmail, price, design, message, recaptchaToken, _localStorage$getItem, _yield$addGiftCardToC, errors, quantity;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref4.commit;
            context = _ref5.context, senderName = _ref5.senderName, recipientName = _ref5.recipientName, recipientEmail = _ref5.recipientEmail, price = _ref5.price, design = _ref5.design, message = _ref5.message, recaptchaToken = _ref5.recaptchaToken;
            _context5.prev = 2;
            if (!(localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken())) {
              _context5.next = 6;
              break;
            }
            _context5.next = 6;
            return logout(_this4.$store);
          case 6:
            if (localStorage.getItem('MDM_CART_TOKEN')) {
              _context5.next = 9;
              break;
            }
            _context5.next = 9;
            return initCart(_this4);
          case 9:
            _context5.next = 11;
            return addGiftCardToCart(context.$apolloProvider, {
              cart: localStorage.getItem('MDM_CART_TOKEN'),
              senderName: senderName,
              recipientName: recipientName,
              recipientEmail: recipientEmail,
              price: price,
              design: design,
              message: message,
              token: (_localStorage$getItem = localStorage.getItem('MDM_ACCESS_TOKEN')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : null,
              recaptchaToken: recaptchaToken
            });
          case 11:
            _yield$addGiftCardToC = _context5.sent;
            errors = _yield$addGiftCardToC.errors;
            if (!errors) {
              _context5.next = 15;
              break;
            }
            throw errors;
          case 15:
            quantity = _this4.getters['cart/total'] + 1;
            commit(types.SET_CART_QTY, quantity);
            commit(types.SET_CART_SUCCESS, true);
            _context5.next = 24;
            break;
          case 20:
            _context5.prev = 20;
            _context5.t0 = _context5["catch"](2);
            _this4.$logger.customFilter(_context5.t0, LOGS.ADD_GIFT_CART);
            throw _context5.t0;
          case 24:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[2, 20]]);
    }))();
  },
  add: function add(_ref6, payload) {
    var _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var commit, state, cart, quantity, isError, item, maxQuantityReached, _yield$addCart, addProductsToCart, errors, totalQuantity, data, currentTotal;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref6.commit, state = _ref6.state;
            cart = state.items;
            quantity = state.total;
            isError = false;
            _context6.prev = 4;
            item = state.items ? state.items.find(function (p) {
              return p.productReference === payload.reference;
            }) : {};
            maxQuantityReached = item && item.quantity >= 30;
            if (!USE_MERCURE(_this5.getters['i18n/locale'].iso)) {
              _context6.next = 32;
              break;
            }
            if (!(localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken())) {
              _context6.next = 11;
              break;
            }
            _context6.next = 11;
            return logout(_this5.$store);
          case 11:
            if (localStorage.getItem('MDM_CART_TOKEN')) {
              _context6.next = 14;
              break;
            }
            _context6.next = 14;
            return initCart(_this5);
          case 14:
            if (maxQuantityReached) {
              _context6.next = 27;
              break;
            }
            _context6.next = 17;
            return addCart(_this5, _objectSpread({
              cart: localStorage.getItem('MDM_CART_TOKEN'),
              token: localStorage.getItem('MDM_ACCESS_TOKEN')
            }, payload));
          case 17:
            _yield$addCart = _context6.sent;
            addProductsToCart = _yield$addCart.data.addProductsToCart;
            errors = _yield$addCart.errors;
            if (!errors) {
              _context6.next = 23;
              break;
            }
            commit(types.SET_CART_SUCCESS_SERVER, false);
            throw new Error(errors[0].message);
          case 23:
            cart = addProductsToCart.items;
            quantity = addProductsToCart.quantity;
            _context6.next = 30;
            break;
          case 27:
            totalQuantity = state.items.reduce(function (acc, pdt) {
              return acc + pdt.quantity;
            }, 0);
            cart = state.items;
            quantity = totalQuantity;
          case 30:
            _context6.next = 38;
            break;
          case 32:
            _context6.next = 34;
            return addCustomerCart(_this5, payload);
          case 34:
            data = _context6.sent;
            currentTotal = state.total;
            cart = [{
              reference: payload.reference,
              productReference: payload.reference,
              quantity: formatCustomerCartQuantity(data)
            }];
            quantity = currentTotal + 1;
          case 38:
            _context6.next = 46;
            break;
          case 40:
            _context6.prev = 40;
            _context6.t0 = _context6["catch"](4);
            isError = true;
            if (!_context6.t0.message || !_context6.t0.message.includes('GraphQL error')) {
              commit(types.SET_CART_SUCCESS_SERVER, false);
            }
            commit(types.SET_CART_SUCCESS, false);
            _this5.$logger.error(_context6.t0);
          case 46:
            _context6.prev = 46;
            if (!isError) {
              commit(types.SET_CART, cart);
              commit(types.SET_CART_QTY, quantity);
              commit(types.SET_CART_SUCCESS, true);
              commit(types.SET_CART_SUCCESS_SERVER, true);
            }
            return _context6.finish(46);
          case 49:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[4, 40, 46, 49]]);
    }))();
  },
  update: function update(_ref7, payload) {
    var _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var commit, cart, quantity, reference, items, _yield$updateCart, updateCartItems, data, response;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            commit = _ref7.commit;
            cart = null;
            quantity = null;
            reference = null;
            items = _this6.state.cart.items.filter(function (e) {
              return e.productReference === payload.reference;
            });
            if (items.length > 1) {
              reference = items.find(function (e) {
                return e.offer === payload.offer;
              }).reference;
            } else {
              reference = items[0].reference;
            }
            _context7.prev = 6;
            if (!USE_MERCURE(_this6.getters['i18n/locale'].iso)) {
              _context7.next = 16;
              break;
            }
            _context7.next = 10;
            return updateCart(_this6, {
              cart: localStorage.getItem('MDM_CART_TOKEN'),
              token: localStorage.getItem('MDM_ACCESS_TOKEN'),
              quantity: payload.quantity,
              reference: reference
            });
          case 10:
            _yield$updateCart = _context7.sent;
            updateCartItems = _yield$updateCart.updateCartItems;
            cart = updateCartItems.items;
            quantity = updateCartItems.quantity;
            _context7.next = 24;
            break;
          case 16:
            _context7.next = 18;
            return updateCustomerCart(_this6, payload);
          case 18:
            data = _context7.sent;
            cart = [{
              reference: payload.reference,
              productReference: payload.reference,
              quantity: data.cartItem
            }];
            _context7.next = 22;
            return fetchCustomerCart(_this6);
          case 22:
            response = _context7.sent;
            quantity = response.cart;
          case 24:
            _context7.next = 30;
            break;
          case 26:
            _context7.prev = 26;
            _context7.t0 = _context7["catch"](6);
            commit(types.SET_CART_SUCCESS, false);
            _this6.$logger.error(_context7.t0);
          case 30:
            _context7.prev = 30;
            commit(types.SET_CART, cart);
            commit(types.SET_CART_QTY, quantity);
            commit(types.SET_CART_SUCCESS, true);
            return _context7.finish(30);
          case 35:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[6, 26, 30, 35]]);
    }))();
  },
  addCartCustomizable: function addCartCustomizable(_ref8, payload) {
    var _this7 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      var state, commit, currentTotal, _yield$_addCartCustom, addCustomizableProductToCart, data;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            state = _ref8.state, commit = _ref8.commit;
            currentTotal = state.total;
            _context8.prev = 2;
            if (!USE_MERCURE(_this7.getters['i18n/locale'].iso)) {
              _context8.next = 19;
              break;
            }
            if (!(localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken())) {
              _context8.next = 7;
              break;
            }
            _context8.next = 7;
            return logout(_this7.$store);
          case 7:
            if (localStorage.getItem('MDM_CART_TOKEN')) {
              _context8.next = 10;
              break;
            }
            _context8.next = 10;
            return initCart(_this7);
          case 10:
            _context8.next = 12;
            return _addCartCustomizable(_this7, {
              cart: localStorage.getItem('MDM_CART_TOKEN'),
              token: localStorage.getItem('MDM_ACCESS_TOKEN'),
              payload: payload
            });
          case 12:
            _yield$_addCartCustom = _context8.sent;
            addCustomizableProductToCart = _yield$_addCartCustom.addCustomizableProductToCart;
            commit(types.SET_CART_QTY, currentTotal + 1);
            commit(types.SET_CART, addCustomizableProductToCart.items);
            commit(types.SET_CART_SUCCESS, true);
            _context8.next = 23;
            break;
          case 19:
            _context8.next = 21;
            return addCustomerCartCustomizable(_this7, payload);
          case 21:
            data = _context8.sent;
            if (data.success) {
              commit(types.SET_CART_QTY, currentTotal + 1);
              commit(types.SET_CART_SUCCESS, true);
            } else {
              commit(types.SET_CART_SUCCESS, false);
            }
          case 23:
            _context8.next = 29;
            break;
          case 25:
            _context8.prev = 25;
            _context8.t0 = _context8["catch"](2);
            commit(types.SET_CART_SUCCESS, false);
            _this7.$logger.error(_context8.t0);
          case 29:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[2, 25]]);
    }))();
  },
  setSellerIdToCart: function setSellerIdToCart(_ref9, _ref10) {
    var _this8 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      var commit, cartToken, sellerId, token, _yield$addSellerIdToC, sellerIdOutput;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            commit = _ref9.commit;
            cartToken = _ref10.cartToken, sellerId = _ref10.sellerId;
            _context9.prev = 2;
            token = localStorage.getItem('MDM_ACCESS_TOKEN');
            _context9.next = 6;
            return addSellerIdToCart(_this8, {
              cartToken: cartToken,
              sellerId: sellerId,
              token: token
            });
          case 6:
            _yield$addSellerIdToC = _context9.sent;
            sellerIdOutput = _yield$addSellerIdToC.seller_id;
            commit(types.SET_CART_SELLER_ID, sellerIdOutput);
            _context9.next = 14;
            break;
          case 11:
            _context9.prev = 11;
            _context9.t0 = _context9["catch"](2);
            _this8.$logger.error('BIND SELLER ID TO CART FAILED', _context9.t0);
          case 14:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[2, 11]]);
    }))();
  }
};